<template>
  <v-app>
    <AppHeader />
    <v-main>
      <router-view />
      <WhatsAppChat />
    </v-main>
    <AppFooter />
  </v-app>
</template>

<script setup>
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import WhatsAppChat from "@/components/WhatsappChat.vue";
</script>
